import { StyleSheet, css } from 'aphrodite';
import React, { ReactNode } from 'react';

import { c } from '@/app/providers/theme-provider/ThemeProvider';

type Props = {
  children: ReactNode;
};

export default function ContentShell({ children }: Props) {
  return <div className={css(styles.container)}>{children}</div>;
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: c('background'),
    color: c('text'),
  },
});
